import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { MedicalGuide } from '../../models/api';
import { AppState } from '../../models/state';
import { EventsService } from '../../services/events.service';
import { StateService } from '../../services/state.service';
import { UtilsService } from '../../services/utils.service';

@Component({
  selector: 'app-medical-guide-feature-table',
  templateUrl: './medical-guide-feature.component.html',
  styleUrls: ['./medical-guide-feature.component.scss']
})
export class MedicalGuideFeatureComponent implements OnDestroy {

  displayedColumns: string[];
  displayedColumnsMobile: string[];
  displayedData: any;
  displayedDataLoaded: boolean;
  dataSource: MatTableDataSource<any>;
  indexSelected: number;
  state: Partial<AppState>;
  subs: Subscription;
  blockScroll: boolean;

  constructor(
    private stateService: StateService,
    private cdr: ChangeDetectorRef,
    private utils: UtilsService,
    private events: EventsService
  ) {
    this.state = this.stateService.getStateValue();
    this.subs = new Subscription();
    this.setEvents();
    this.setTableSourceData();
  }

  ngAfterViewInit() {
    if (!this.state.isDesktop) {
      const index = this.indexSelected || 0;
      this.updateMobileTable(index);
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  onColumnClick(index: number) {
    if (index === 0) return;
    this.blockScroll = true;
    this.events.selectedIndexEvent$.next(index - 1);
  }

  showCheckIcon(e, column): boolean {
    const feature = e.Características;
    const medicalGuide: Partial<MedicalGuide> = this.state.medicalGuides.find(m => m.descripcionProductoGenerico === column);
    return medicalGuide.caracteristicas.includes(feature);
  }

  private setTableSourceData() {
    this.setDisplayedColumns();
    this.setDataSource();
    this.displayedDataLoaded = true;
  }

  private setDataSource() {
    const medicalGuide: Partial<MedicalGuide> = this.utils.clone(this.state.medicalGuides[this.indexSelected || 0]);
    const allFeatures = Array.from(new Set(this.state.medicalGuides.map(m => m.caracteristicas)?.flat()));
    let temp = allFeatures.map(feature => ({
      Características: feature
    }));

    temp.forEach((ele) => {
      this.displayedColumns.forEach((key, i) => {
        if (i > 0) ele[key] = true;
      });
    });

    this.displayedData = temp;
    this.dataSource = this.displayedData;

    setTimeout(() => {
      this.cdr.detectChanges();
    });
  }


  private setDisplayedColumns() {
    const index = this.indexSelected ? (this.indexSelected + 1) : 1;
    this.displayedColumns = [
      'Características',
      ...this.state.medicalGuides.map(ele => ele.descripcionProductoGenerico)
    ];
    this.displayedColumnsMobile = [
      'Características',
      this.displayedColumns[index]
    ];

  }

  private setEvents() {
    this.subs.add(
      this.stateService.getState().subscribe(state => {
        this.state = state;
      })
    );

    this.subs.add(
      this.events.selectedIndexEvent().subscribe(index => {
        this.indexSelected = index;
        this.setDataSource();
        this.updateMobileTable(index);
        if (this.state.isDesktop && !this.blockScroll) {
          setTimeout(() => {
            this.scrollTo(index);
          });
        }

        this.blockScroll = false;
        this.cdr.detectChanges();
      })
    );
  }

  private updateMobileTable(index: number) {
    this.displayedColumnsMobile = ['Características', this.displayedColumns[index + 1]?.toString()];
  }

  private scrollTo(index: number) {
    const tableContaier = document.getElementsByClassName('table-container')[0];
    const scrollLeft = (160 * index);
    tableContaier.scrollLeft = scrollLeft;
  }
}
